import * as THREE from 'three';
import profileData from './mt150-profiles.json';
import { makeMT150Profile } from './mt150Profiles';

export function makeMT150RailSpecimen(product, type, frame, materials) {
  const group = new THREE.Group(), family = product.track_count === 3 ? 'three' : 'two';
  const data = profileData[family];
  const rail = makeMT150Profile(family, type, .42, frame, materials, true);
  rail.name = `mt150-${family}-${type}`;
  group.add(rail);
  group.userData = { ...rail.userData, productId: product.id, type };
  if (type === 'sill') {
    // Retain the same sash/track relationship as the complete MT150 model.
    // A short sample at the far end leaves the running channels and cut face exposed.
    const z = (data.tracks - 1) * data.track_pitch_mm / 2000;
    const sash = makeMT150Profile(family, 'sash', .12, frame, materials, true);
    sash.position.set(-.15, data.sash_bottom_offset_mm / 1000, z);
    group.add(sash);
    for (const dz of [-.011, .011]) {
      const glass = new THREE.Mesh(new THREE.BoxGeometry(.12, .07, .006), materials.glass);
      glass.position.set(-.15, .138, z + dz); group.add(glass);
    }
  } else {
    // Keep the head in its installed orientation, with the guide channels below.
    rail.position.y = .055;
  }
  return group;
}